import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import ECardAddFolder from './ECardAddFolder';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientId: string;
	workplaceId?: string;
	defaultData?: any;
	params?: any;
}

const ECardAddFolderModal: React.FC<Props> = ({
	opened,
	onClose,
	patientId,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<div>
			<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
				<Modal.Header title={'base.newFolder'} />
				<Modal.Content>
					<ECardAddFolder patientId={patientId} onSuccess={onClose} />
				</Modal.Content>
			</Modal>
		</div>
	);
};

export default ECardAddFolderModal;
